import { V2EventUpdateRequestDtoCategory } from "@everon-it/api-client/contents-gw";
import { type EventCommonContentsOptionType, EventNoti } from "@pages/EventCreate/Data";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type EventDetailInitValuesType = {
    title: string;
    displayStartAt: string;
    displayEndAt: string;
    isVisible: boolean;
    eventStartAt: string;
    eventEndAt: string;
    thumbnailUrl: string;
    contentCategory: string;
    content: string;
    url: string;
    urls: { title: string; url: string }[] | undefined;
};

export const EventDetailData: CommonDataType<CommonCreateBodyKeyType, EventDetailInitValuesType, EventCommonContentsOptionType> = {
    createBodyKey: ["title", "isVisible", "eventStartAt", "eventEndAt", "displayStartAt", "displayEndAt", "thumbnailUrl", "urls", "content"],
    formInitialValues: {
        title: "",
        displayStartAt: "",
        displayEndAt: "",
        isVisible: false,
        eventStartAt: "",
        eventEndAt: "",
        thumbnailUrl: "",
        contentCategory: V2EventUpdateRequestDtoCategory.CONTENT,
        content: "",
        url: "",
        urls: undefined,
    },
    contentsOption: [
        {
            label: "게시 날짜",
            name: "displayStartAt",
            secondName: "displayEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "썸네일 이미지",
            name: "thumbnailUrl",
            type: CommonElementType.IMAGE_UPLOAD,
            size: "medium",
            isSizeQuestion: true,
        },
        {
            label: "제목",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "제목을 입력해주세요",
        },
        {
            label: "이벤트 기간",
            name: "eventStartAt",
            secondName: "eventEndAt",
            type: CommonElementType.DATE_RANGE_PICKER,
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
            notice: EventNoti,
        },
        {
            label: "내용",
            name: "contentCategory",
            type: CommonElementType.RADIO,
            options: [
                { label: "직접작성", value: V2EventUpdateRequestDtoCategory.CONTENT },
                { label: "URL 연결", value: V2EventUpdateRequestDtoCategory.URL },
                { label: "이벤트 버튼 생성", value: V2EventUpdateRequestDtoCategory.BUTTON },
            ],
        },
    ],
};
